import { FC } from 'react'

import { Tooltip } from '@avantstay/backoffice-core'

import * as S from './TruncatedListPreview.styles'

interface TruncatedListPreviewProps {
  names: string[]
}

const MAX_VISIBLE_ITEMS = 1
const TOOLTIP_MAX_WIDTH = 280

export const TruncatedListPreview: FC<TruncatedListPreviewProps> = ({ names }) => {
  if (!names.length) return null

  const remainingCount = names.length - MAX_VISIBLE_ITEMS
  const visibleText = names.slice(0, MAX_VISIBLE_ITEMS).join(', ')
  const parsedText = remainingCount > 0 ? `${visibleText}, + ${remainingCount}` : visibleText

  return (
    <Tooltip
      interactive
      maxWidth={TOOLTIP_MAX_WIDTH}
      disabled={remainingCount <= 0}
      content={
        <S.ScrollableList>
          {names.map((name, index) => (
            <p key={`${name}-${index}`}>{name}</p>
          ))}
        </S.ScrollableList>
      }
    >
      <span>{parsedText}</span>
    </Tooltip>
  )
}
